export default "__VITE_ASSET__DCwL0sLC__"